export default {"src":"/_next/static/media/calendar.6de165ce.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};